/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateAddonDto = {
    /**
     * Add-on name (unique, max 100 chars)
     */
    name: string;
    /**
     * Add-on price (decimal, min 0)
     */
    price: number;
    /**
     * Duration in days (null = one-time / permanent)
     */
    durationDays?: number;
    /**
     * Add-on description
     */
    description?: string;
    /**
     * Add-on type
     */
    addonType: CreateAddonDto.addonType;
    /**
     * Whether the add-on is active (default: true)
     */
    isActive?: boolean;
};
export namespace CreateAddonDto {
    /**
     * Add-on type
     */
    export enum addonType {
        IN_APP = 'in_app',
        OFFLINE_MARKETING = 'offline_marketing',
    }
}

